import { Chart, ChartTimerName } from '@frontend/chart/types';

export const PUDO_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_DONUT_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: ChartTimerName.TRANSACTION_DROP_OFF_PENDING,
            data: [
                { label: '0', value: 12 },
                { label: '1', value: 4 },
                { label: '2', value: 2 },
                { label: '3', value: 1 },
                { label: '4', value: 1 },
                { label: '5', value: 0 },
                { label: '6', value: 1 }
            ]
        }
    ]
};
